import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'results'];
  static values = { url: String };

  connect() {
    this._timer = null;
    this._open = false;

    // Close on click outside
    this._outsideClick = (e) => {
      if (!this.element.contains(e.target)) this.close();
    };
    document.addEventListener('click', this._outsideClick);
  }

  disconnect() {
    clearTimeout(this._timer);
    document.removeEventListener('click', this._outsideClick);
  }

  onInput() {
    clearTimeout(this._timer);
    const q = this.inputTarget.value.trim();

    if (q.length < 2) {
      this.resultsTarget.innerHTML = '';
      this._open = false;
      return;
    }

    this._timer = setTimeout(() => {
      this._fetchResults(q);
    }, 250);
  }

  close() {
    this.resultsTarget.innerHTML = '';
    this._open = false;
  }

  onKeydown(e) {
    if (e.key === 'Escape') this.close();
  }

  async _fetchResults(q) {
    const url = `${this.urlValue}?q=${encodeURIComponent(q)}`;
    const resp = await fetch(url, {
      headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (resp.ok) {
      this.resultsTarget.innerHTML = await resp.text();
      this._open = true;
    }
  }
}
